// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as CustomerApiHandler from "../state-machine/CustomerApiHandler.bs.js";
import * as EditWalletModalCmp from "./EditWalletModalCmp.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CustomerAssetsManager from "../assets/CustomerAssetsManager.bs.js";
import * as SendPaymentLinkModalCmp from "./SendPaymentLinkModalCmp.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as TransactionHistoryStateMachine from "../state-machine/TransactionHistoryStateMachine.bs.js";
import * as CustomerTransactionTableWrapper from "./CustomerTransactionTableWrapper.bs.js";

function CustomerWalletInfoCmp(Props) {
  var data = Props.data;
  var customer_id = Props.customer_id;
  var openSnackbar = Props.openSnackbar;
  var match = React.useState(function () {
        return true;
      });
  var setCollapse = match[1];
  var collapse = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setShowModal = match$1[1];
  var showModal = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setLoader = match$2[1];
  var match$3 = React.useReducer(TransactionHistoryStateMachine.StateMachine.machine, /* Init */0);
  var dispatch = match$3[1];
  var state = match$3[0];
  var expendIcon = CustomerAssetsManager.getImage("expand_content.svg");
  var match$4 = CountryContext.useContext(undefined);
  var country = match$4.country;
  var symbol = CountryConfig.getSymbol(country);
  var toggleModal = function (modal) {
    return Curry._1(setShowModal, (function (param) {
                  if (showModal !== undefined) {
                    return ;
                  } else {
                    return modal;
                  }
                }));
  };
  var fetchTransactionHistory = function (uuid, page_size, last_date_timestamp) {
    return function (param) {
      return CustomerApiHandler.FetchTransactionHistory.execute((function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* SetTransactionHistory */0,
                                _0: data
                              });
                  }), (function (error) {
                    return Curry._1(dispatch, {
                                TAG: /* SetTransactionHistoryFailed */1,
                                _0: error
                              });
                  }), uuid, page_size, last_date_timestamp, param);
    };
  };
  React.useEffect((function () {
          fetchTransactionHistory(data.uuid, 20, undefined)(country);
          
        }), []);
  if (typeof state === "number") {
    return React.createElement(LoadingViewComponent$Catalyst.make, {});
  }
  if (state.TAG !== /* TransactionHistory */0) {
    return null;
  }
  var res = state._0;
  var tmp;
  if (showModal !== undefined) {
    if (showModal) {
      var partial_arg = res.wallet_balance;
      tmp = React.createElement(EditWalletModalCmp.make, {
            update_wallet_balance: (function (param) {
                return CustomerApiHandler.UpdateWalletBalance.execute((function (wallet_balance) {
                              Curry._1(openSnackbar, {
                                    TAG: /* Success */0,
                                    _0: "Changes in Wallet Balance is made successfully"
                                  });
                              return Curry._1(dispatch, {
                                          TAG: /* UpdateWalletBalance */4,
                                          _0: wallet_balance
                                        });
                            }), (function (error) {
                              return Curry._1(dispatch, {
                                          TAG: /* UpdateWalletBalanceFailure */5,
                                          _0: error
                                        });
                            }), customer_id, partial_arg, param, Timestamp$Catalyst.now(undefined), country);
              }),
            onCloseCb: (function (param) {
                return toggleModal(showModal);
              })
          });
    } else {
      tmp = React.createElement(SendPaymentLinkModalCmp.make, {
            toggle_modal: (function (param) {
                return toggleModal(showModal);
              }),
            customer_id: customer_id,
            data: data
          });
    }
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "customer-wallet-container"
            }, React.createElement("h2", {
                  className: "title"
                }, "Wallet Information", React.createElement("span", {
                      onClick: (function (param) {
                          return Curry._1(setCollapse, (function (param) {
                                        return !collapse;
                                      }));
                        })
                    }, React.createElement("img", {
                          src: expendIcon
                        }))), React.createElement("div", {
                  className: "wallet-info-conatiner"
                }, React.createElement("div", {
                      className: "card-conatiner"
                    }, React.createElement("div", {
                          className: "card"
                        }, React.createElement("p", {
                              className: "label"
                            }, "Wallet Balance"), React.createElement("p", {
                              className: "value"
                            }, Currency.toCurrencyString(res.wallet_balance, symbol))), null), React.createElement(CustomerTransactionTableWrapper.make, {
                      collapse: collapse,
                      setCollapse: (function (value) {
                          return Curry._1(setCollapse, (function (param) {
                                        return value;
                                      }));
                        }),
                      data: res,
                      updateTable: (function (list_last_time) {
                          if (Caml_obj.caml_equal(list_last_time, "0")) {
                            return ;
                          } else {
                            Curry._1(setLoader, (function (param) {
                                    return true;
                                  }));
                            return CustomerApiHandler.FetchTransactionHistory.execute((function (data) {
                                          Curry._1(setLoader, (function (param) {
                                                  return false;
                                                }));
                                          return Curry._1(dispatch, {
                                                      TAG: /* UpdateTransactionHistory */2,
                                                      _0: data
                                                    });
                                        }), (function (error) {
                                          Curry._1(setLoader, (function (param) {
                                                  return false;
                                                }));
                                          return Curry._1(dispatch, {
                                                      TAG: /* UpdateTransactionHistoryFailed */3,
                                                      _0: error
                                                    });
                                        }), data.uuid, 50, list_last_time, country);
                          }
                        }),
                      loader: match$2[0]
                    }), tmp));
}

var make = CustomerWalletInfoCmp;

export {
  make ,
  
}
/* react Not a pure module */
